import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { CtSelectControlOptions, CTModelDatatableFilter, CtBinaryOperator, CtModelDatatableOperators, CtSortOrderDescriptorParameter, CtControlTypes, CtSelectControlValue, CtButtonConfiguration, MAT_RAISED_PRIMARY, CtFormConfiguration, SnackbarService, CtControlService, CtThemeTypes, CtModelConfiguration, CtGenericDialogConfiguration } from '@ctsolution/ct-framework';
import { CtWebapiService, CtWebapiGenericResponse, DataRequest, MethodEnum } from '@ctsolution/ct-webapi';
import { WorkOrderPayment } from 'projects/ct-manager/src/app/_core/classes/work-order-payments';
import { CTMGeneralService } from 'projects/ct-manager/src/app/_core/lib/general.service';
import { WorkOrderRouteData } from 'projects/ct-manager/src/app/_core/route-data/work-order.route-data';
import { MassiveChangesService } from '../../massive-changes.service';
import { CustomCtFormContainerHelper } from 'projects/ct-manager/src/app/_core/services/custom-ct-form.helper';

@Component({
  selector: 'app-massive-admin-payment',
  templateUrl: './massive-admin-payment.component.html',
  styleUrls: ['./massive-admin-payment.component.scss']
})
export class MassiveAdminPaymentComponent implements OnInit {

  private contactControl = this.generalService
  .getLookupControlDefaultConfiguration({
    name: 'Contact',
    controller: 'Contact',
    key: 'Name',
    action: 'Lookup',
    required: true,
  })
  .setFlexSpacePercentage(50)
  .setLabel('Amministratore')
  .configureOptions<CtSelectControlOptions>(options => {

    if (!options) options = CtSelectControlOptions.create();

    options
      .setNullValueEnabled(true)
      .setLookupFilter((value) => {

        const adminFilter = CTModelDatatableFilter.create().setField("Type.Code").setOperatorType(CtBinaryOperator.Equal).setValue("ADMIN");

        const filters: CTModelDatatableFilter[] = [adminFilter];

        if (value) {

          filters
            .push(
              CTModelDatatableFilter
                .create()
                .setField("Name")
                .setValue(value)
                .setOperatorType(CtBinaryOperator.Contains)
            );
        }

        filters.push(this.customCtFormContainerHelper.getFilterForLookupCompanyOrContact(this.contactControl))

        const operators = CtModelDatatableOperators
          .create()
          .setFilters(filters);

        operators
          .Pagination
          ?.setSortOrders(new Array<CtSortOrderDescriptorParameter>(CtSortOrderDescriptorParameter.create('Name')))

        return operators;

      })

  });

  private offerTypeLookup = this.generalService
  .getLookupControlDefaultConfiguration({
    name: 'Utility',
    controller: 'OfferType',
    key: 'Name',
    action: 'Lookup',
    required: false
    })
  .setFlexSpacePercentage(50)


  searchButton : CtButtonConfiguration = CtButtonConfiguration.create()
  .setAction(() => this.searchWorkOrder())
  .setLabel("Search")
  .setMatherialOptions(MAT_RAISED_PRIMARY)
  .setClass("button-cntr");

  submitButton : CtButtonConfiguration = CtButtonConfiguration.create()
  .setAction(() => this.submit())
  .setLabel("Submit")
  .setMatherialOptions(MAT_RAISED_PRIMARY)
  .setClass("button-cntr");

  formConfiguration: CtFormConfiguration | null = null;
  submitFormConfiguration: CtFormConfiguration | null = null;

  elements: WorkOrderPayment[] | null = null;
  selectedElements = [];



  constructor(private snackBar : SnackbarService, private customCtFormContainerHelper : CustomCtFormContainerHelper, private generalService : CTMGeneralService, private fb: FormBuilder, private ctControlService : CtControlService, private cdr : ChangeDetectorRef, private _webapi : CtWebapiService,private massiveChangesService : MassiveChangesService) {

    this.formConfiguration = CtFormConfiguration
    .create(this.fb.group({}))
    .setTheme(CtThemeTypes.MATERIAL)
    .setControls([this.contactControl,this.offerTypeLookup]);

  }

  ngOnInit() {


  }

  private searchWorkOrder(){

    this.formConfiguration?.form?.markAllAsTouched();

    if(this.formConfiguration?.form?.valid == false) return;

    const param = {

      ContactOid : this.formConfiguration?.form?.get('Contact')?.value.value,
      OfferTypeOid : this.offerTypeLookup.control?.value?.value,

    }

    this._webapi.post(getWorkOrderFilterList(param)).subscribe((response: CtWebapiGenericResponse<any>) => {

      this.elements = [];
      this.elements = [...response.Result];
      this.cdr.detectChanges();
    });

  }

  private submit(){

    this.submitFormConfiguration?.form?.markAllAsTouched();

    if(this.selectedElements.length < 1) this.snackBar.open("Seleziona almeno un elemento!");

    if(this.submitFormConfiguration?.form?.valid == false || this.selectedElements.length < 1) return;

    const WorkOrdersOid: number[] = this.selectedElements.map((element : any) => element.Oid);

    const dialogConfig = CtGenericDialogConfiguration.create()
    .setTitle("Attenzione")
    .setContent(`Stai per modificare ${WorkOrdersOid.length} contratti. La Modalità di Pagamento verrà riportata a quella impostata sull'Amministratore`)
    .setSubmitLabel("Conferma")
    .setCancelLabel("Annulla")

    this.massiveChangesService.open(dialogConfig).afterClosed().subscribe((res : any) => {

         if(res)
        {
          this._webapi.post(MassiveChangeOffer({
            WorkOrdersOid: WorkOrdersOid,
            SetAdministratorPaymentModeNull: true
          })).subscribe((response: CtWebapiGenericResponse<any>) => {

            this.searchWorkOrder();
            this.snackBar.onSuccess()

          });

        }

    });

  }
}

export const getWorkOrderFilterList : (param : any) => DataRequest = (param : any) => new DataRequest()
.setController([WorkOrderRouteData().controller!])
.setAction('GetWorkOrdersForMassiveChangeAdministratorPaymentMode')
.setMethod(MethodEnum.POST)
.setBody(param);


export const MassiveChangeOffer : (param : any) => DataRequest = (param : any) => new DataRequest()
.setController([WorkOrderRouteData().controller!])
.setAction('MassiveChangeWorkOrderData')
.setMethod(MethodEnum.POST)
.setBody(param);
